export const Keycode = {
	ENTER: 13,
	ESC: 27,
	SPACE: 32,
	ARROW_TOP: 38,
	ARROW_BOTTOM: 40,
	ARROW_LEFT: 37,
	ARROW_RIGHT: 39,
};

export const STRICT_NAME_REGEX = /^[a-zA-Zа-яА-Я\s-]*$/;
